import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import MicOffIcon from "@mui/icons-material/MicOff";
import { cameraOffPresenceCopy, micOffPresenceLabel } from "./videoCallCopy";
import { sanitizeAvatarUrl, videoInitials } from "./videoMediaPresence";
import VoFloorSeat from "./VoFloorSeat";

/**
 * Placeholder Meet-like quando a câmera está desligada (pré-join e PIP local).
 */
export default function VideoCameraOffPresence({
  name = "",
  avatarUrl = "",
  self = false,
  muted = false,
  compact = false,
  primary = "#1a73e8",
  virtualOffice = false,
  status = "present",
  cargo = "",
}) {
  if (virtualOffice) {
    return (
      <VoFloorSeat
        name={name}
        avatarUrl={avatarUrl}
        self={self}
        muted={muted}
        camOff
        compact={compact}
        primary={primary}
        status={status}
        cargo={cargo}
      />
    );
  }
  const copy = cameraOffPresenceCopy({ self, name, muted, compact });
  const src = sanitizeAvatarUrl(avatarUrl);
  const initials = videoInitials(name || (self ? "Você" : "Participante"));
  const size = compact ? 44 : 96;
  const badge = compact ? 18 : 28;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={compact ? 0.75 : 1.5}
      sx={{
        position: "absolute",
        inset: 0,
        px: compact ? 0.75 : 2.5,
        background:
          "radial-gradient(ellipse at 50% 38%, rgba(95,99,104,0.5), transparent 58%), linear-gradient(180deg, #2d3134 0%, #202124 100%)",
      }}
    >
      <Box sx={{ position: "relative", flexShrink: 0 }}>
        <Avatar
          src={src || undefined}
          alt={name || ""}
          sx={{
            width: size,
            height: size,
            bgcolor: primary,
            fontSize: compact ? "0.95rem" : "2rem",
            fontWeight: 700,
            boxShadow: "0 8px 28px rgba(0,0,0,0.35)",
          }}
        >
          {initials}
        </Avatar>
        <Box
          sx={{
            position: "absolute",
            right: compact ? -2 : 0,
            bottom: compact ? -2 : 0,
            width: badge,
            height: badge,
            borderRadius: "50%",
            bgcolor: "#ea4335",
            color: "#fff",
            display: "grid",
            placeItems: "center",
            border: "2px solid #202124",
            boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
          }}
          aria-hidden
        >
          <VideocamOffIcon sx={{ fontSize: compact ? 11 : 16 }} />
        </Box>
      </Box>
      {!compact ? (
        <>
          <Typography
            sx={{
              color: "#f1f3f4",
              fontSize: { xs: "1rem", md: "1.15rem" },
              fontWeight: 600,
              textAlign: "center",
              lineHeight: 1.3,
              px: 1,
            }}
          >
            {copy.title}
          </Typography>
          <Typography
            sx={{
              color: "#dadce0",
              fontSize: "0.86rem",
              textAlign: "center",
              lineHeight: 1.45,
              maxWidth: 360,
            }}
          >
            {copy.body}
          </Typography>
        </>
      ) : (
        <Typography
          sx={{
            color: "#e8eaed",
            fontSize: "0.62rem",
            fontWeight: 600,
            textAlign: "center",
            lineHeight: 1.25,
            px: 0.25,
          }}
        >
          {copy.body}
        </Typography>
      )}
      {muted && !compact ? (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.6,
            color: "#f28b82",
            bgcolor: "rgba(234,67,53,0.16)",
            border: "1px solid rgba(242,139,130,0.35)",
            px: 1.1,
            py: 0.35,
            borderRadius: 999,
            fontSize: "0.75rem",
            fontWeight: 600,
          }}
        >
          <MicOffIcon sx={{ fontSize: 14 }} />
          {micOffPresenceLabel({ self })}
        </Box>
      ) : null}
    </Stack>
  );
}
